import { Controller } from "@hotwired/stimulus";

// Tells the server about something the visitor did on the page, then queues
// the same event for the pixel under the id the server recorded, so Meta
// folds the two into one. No id back means nothing to fire: no consent, or
// this kind was already counted in this visit.
export default class extends Controller {
  static values = { url: String };

  async report({ params: { kind } }) {
    // keepalive lets the request finish when a store badge takes the page away.
    const response = await fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      },
      body: JSON.stringify({ kind })
    }).catch(() => null);
    if (!response?.ok) return;

    const { name, event_id: eventID } = await response.json().catch(() => ({}));
    if (eventID) (window.oremusFbq = window.oremusFbq || []).push(["track", name, {}, { eventID }]);
  }
}
